import { render } from "./BusinessAddress.vue?vue&type=template&id=84e09c04&scoped=true"
import script from "./BusinessAddress.vue?vue&type=script&lang=js"
export * from "./BusinessAddress.vue?vue&type=script&lang=js"

import "./BusinessAddress.vue?vue&type=style&index=0&id=84e09c04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84e09c04"]])

export default __exports__